import React, {useEffect, useState} from "react";
import {Button, ButtonGroup, Divider, Input, Checkbox, SelectItem, Select} from "@nextui-org/react";
import { FaIdCardAlt} from 'react-icons/fa';
import {useLocation} from "react-router-dom";
import {getMachines, ParentsPosition} from "../API";


export default function Positions() {
    const location = useLocation();
    const { data } = location.state || {};

    const [position, setPosition] = useState([]);
    const [parents, setParents] = useState([]);
    const [machines, setMachines] = useState([]);
    useEffect(
        () => {
            Starting();
        }, []
    )

    async function Starting(){
        const m = await getMachines();
        const pa = await ParentsPosition(data.idmachine);
        setParents(pa);
        setMachines(m);
        setPosition(data);
    }


    function OnChange(e) {
        if(e.target.name === "main_door") {
            setPosition({...position, [e.target.name]: e.target.checked});
        }else
            setPosition({...position, [e.target.name]: e.target.value});
    }

    return (
        <>

            <h1 className="pb-5 text-2xl">Posicion: <b className='text-warning'>{position.idposition === undefined ? "Nuevo" : `${position.idmachine} - ${position.code}`}</b></h1>

            <div className="flex flex-col gap-4">
                <form className="flex w-full flex-wrap gap-4">
                   <h2 className="text-xl text-warning">Datos generales</h2>
                    <Select
                        labelPlacement="outside"
                        label="Maquina"
                        isRequired
                        required
                        selectedKeys={[position.idmachine]}
                        name="parent"
                        onChange={OnChange}
                        items={machines}>
                        {
                            (items)=>(<SelectItem key={items.idmachine} value={items.idmachine}>{items.idmachine}</SelectItem>)
                        }
                    </Select>
                    <Input
                        type="text"
                        label="Codigo"
                        labelPlacement="outside"
                        value={position.code}
                        onChange={OnChange}
                        name="code"
                        required
                        isRequired
                    />
                    <Checkbox defaultSelected={position.main_door} color="warning" onChange={OnChange} name="main_door" value={position.main_door}>Puerta principal</Checkbox>
                    <Select
                        isDisabled={position.main_door}
                        labelPlacement="outside"
                        label="Puerta padre"
                        isRequired
                        required
                        selectedKeys={[position.parent]}
                        name="parent"
                        onChange={OnChange}
                        items={parents}>
                        {
                            (items)=>(<SelectItem key={items.code} value={items.idposition}>{items.code}</SelectItem>)
                        }
                    </Select>
                    <Input
                        type="number"
                        label="Sequencia"
                        isDisabled={position.main_door}
                        name="sequence"
                        labelPlacement="outside"
                        value={position.sequence}
                        onChange={OnChange}
                        required
                        isRequired
                    />
                    <Input
                        type="text"
                        label="Estado"
                        labelPlacement="outside"
                        value={position.status}
                        name="status"
                        onChange={OnChange}
                        required
                        isRequired
                    />
                    <Input
                        type="text"
                        label="Descripcion"
                        labelPlacement="outside"
                        value={position.description}
                        onChange={OnChange}
                    />


                    <div className="container text-center">
                        <Button color="success" type="submit" size="lg">{position.idposition === 0 ? "Crear" : "Actualizar"}</Button>
                    </div>

                </form>

            </div>
        </>
    );
}
